module.exports = __webpack_public_path__ + "static/media/people-and-role.c801b11b.svg";